import { render, staticRenderFns } from "./consent-questions.vue?vue&type=template&id=32c13354&scoped=true&"
import script from "./consent-questions.vue?vue&type=script&lang=js&"
export * from "./consent-questions.vue?vue&type=script&lang=js&"
import style0 from "./consent-questions.vue?vue&type=style&index=0&id=32c13354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c13354",
  null
  
)

component.options.__file = "consent-questions.vue"
export default component.exports